import { useAnalytics } from "@volumental/analytic";
import { Button, Headline, TextButton } from "@volumental/common";
import type { JSX } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Modal } from "../../../components/modal/modal";
import { usePersistedViewStore } from "../../../store";
import { CookieType } from "../../../types/types";

interface CookieModalProps {
  close: () => void;
  next: () => void;
  show: boolean;
}

export function CookieModal({ close, next, show }: CookieModalProps): JSX.Element {
  const cookieLink = "https://volumental.com/policy/cookie-policy";
  const dataProtectionLink = "https://volumental.com/policy/privacy-policy";
  const { optOutUser } = useAnalytics();
  const { setCookieType } = usePersistedViewStore((store) => store);
  const { t } = useTranslation();

  return (
    <Modal show={show} close={close} fitContent disableScrollBar modalTitle={t("cookiesModal.title")}>
      <Headline className="text-xl font-bold">{t("cookiesModal.title")}</Headline>
      <div className="text-black font-normal text-base leading-[21px] mb-6">
        <Trans
          i18nKey="cookiesModal.description"
          components={{
            link1: <a href={cookieLink} target="_blank" className="font-bold text-black" rel="noreferrer" />,
            link2: <a href={dataProtectionLink} target="_blank" className="font-bold text-black" rel="noreferrer" />,
          }}
        />
      </div>
      <div className="pb-7.5 flex flex-col justify-center">
        <Button
          loading={false}
          type="submit"
          onClick={() => {
            setCookieType(CookieType.All);
            next();
          }}
        >
          {t("cookiesModal.acceptBT")}
        </Button>
        <TextButton
          onClick={() => {
            setCookieType(CookieType.Essential);
            optOutUser(true);
            next();
          }}
          className="mt-6"
        >
          {t("cookiesModal.limitBt")}
        </TextButton>
      </div>
    </Modal>
  );
}
